import React from 'react';
import ImageLoader, { ImageLoaderProps } from '../Image/ImageLoader';
import { makeCSS, PropsWithTheme } from '../../../utils/makeCSS';
import { BrandLogo } from '../BrandLogo/BrandLogo';
import { SizeVariants } from '../../../theme/themes';

const useCSS = makeCSS(({ theme, autoWidth }: PropsWithTheme<LogoProps>) => ({
  root: {
    width: autoWidth ? 'auto' : theme.spacing[12], // 48px
    height: 'auto',
    maxHeight: theme.spacing[12],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start'
  },
  image: {
    width: 'auto',
    height: 'auto',
    maxWidth: autoWidth ? 'auto' : theme.spacing[12],
    maxHeight: theme.spacing[12],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      minHeight: '100%'
    }
  }
}));

export interface LogoProps extends ImageLoaderProps {
  autoWidth?: boolean;
}

// TODO: update peekplaceholder once we have something in place
export function Logo(props: LogoProps) {
  const { fallback, peekPlaceholder, borderRadius = 8 } = props;
  const classes = useCSS(props);

  return (
    <div className={classes.root}>
      <ImageLoader
        {...props}
        className={classes.image}
        peekPlaceholder={peekPlaceholder || 'rgba(125,125,125,0.4)'}
        fallback={
          fallback || (
            <BrandLogo logo={'cube_White'} size={SizeVariants['6xl']} />
          )
        }
        borderRadius={borderRadius}
      />
    </div>
  );
}

export default Logo;
